package com.eladfinish.bible.contest.screens.search.analytics

import com.eladfinish.bible.contest.ads.GetAdFreeStateUseCase
import com.eladfinish.bible.contest.platform.AppInfoProvider
import com.eladfinish.bible.contest.platform.platformInfo
import com.eladfinish.contract.analytics.SearchAnalyticsEvent
import kotlin.time.Clock

class SearchAnalyticsEventFactory(
    private val anonymousInstallationIdProvider: AnonymousInstallationIdProvider,
    private val appInfoProvider: AppInfoProvider,
    private val getAdFreeState: GetAdFreeStateUseCase,
) {

    fun createSearchEvent(
        query: String,
        searchMode: String,
        searchPlace: String,
        withNikud: Boolean,
        withTeamim: Boolean,
        onlyQri: Boolean,
        resultsCount: Int,
        durationMs: Long,
        cancelledByUser: Boolean,
        source: String,
    ): SearchAnalyticsEvent {
        return SearchAnalyticsEvent(
            query = query,
            searchMode = searchMode,
            searchPlace = searchPlace,
            withNikud = withNikud,
            withTeamim = withTeamim,
            onlyQri = onlyQri,
            resultsCount = resultsCount,
            durationMs = durationMs,
            cancelledByUser = cancelledByUser,
            source = source,
            appVersion = appInfoProvider.appVersionName(),
            platform = platformInfo.name,
            deviceModel = appInfoProvider.deviceModel(),
            anonymousInstallationId = anonymousInstallationIdProvider.getAnonymousInstallationId(),
            timestamp = Clock.System.now().toString(),
            adFree = getAdFreeState(),
        )
    }
}
